import React from "react"

import {
	Box,
	Button,
	Grid,
	Stack,
	Typography,
} from "@mui/material"

import {
	t,
	Trans,
} from "@lingui/macro"
import { UseFormReturn } from "react-hook-form"
import * as Yup from "yup"

import {
	MatesMultilineTextField,
	MatesSelect,
	MatesTextField,
	withUseFormHook,
} from "@sinossi/mates-react-library"
import { SendTicketRequest } from "models/send-ticket"
import { PageSectionTitle } from "components/commons"



const SupportFormSchema = Yup.object().shape({
	name: Yup.string().required('Il campo è obbligatorio'),
	email: Yup.string().required('Il campo è obbligatorio'),
	object: Yup.string().required('Il campo è obbligatorio'),
	type: Yup.string().required('Il campo è obbligatorio'),
	message: Yup.string().required('Il campo è obbligatorio'),
})

const requestTypes = [
	"Gestione Immobili",
	"Gestione Brand",
	"Microjobs e Utenti",
	"Aperture",
	"Repository Documenti",
	"Gestione Economica",
	"Reportistica e Analytics",
	"Supporto e Documentazione"
]

interface SupportFormProps extends UseFormReturn {
	submitForm: (request: SendTicketRequest) => void
}

interface SupportFormState {
	isFormLoaded: boolean,
}


class SupportForm extends React.Component<SupportFormProps, SupportFormState> {

	constructor(props: any) {
		super(props);

		this.state = {
			isFormLoaded: false
		};
	}

	private submitForm = () : void => {

		let request: SendTicketRequest = {
			name: this.props.getValues("name"),
			email: this.props.getValues("email"),
			object: this.props.getValues("object"),
			type: this.props.getValues("type"),
			message: this.props.getValues("message")
		}

		this.props.submitForm(request)
	}


	render(){

		return <>
			<form onSubmit={this.props.handleSubmit(this.submitForm)}>
					<Grid container spacing={2} px={5}>
						<Grid item xs={12} md={2} display="flex" alignItems="center">
							<Typography>
								<Trans id="sf-ticket-name">Nome</Trans>
							</Typography>
						</Grid>
						<Grid item xs={12} md={10}>
							<MatesTextField
								variant={"outlined"}
								label={t({
									id: "sf-ticket-name",
									message: "Nome",
								})}
								name="name"
								control={this.props.control}
								trigger={this.props.trigger}
								formState={this.props.formState}
							/>
						</Grid>

						<Grid item xs={12} md={2} display="flex" alignItems="center">
							<Typography>
								<Trans id="sf-ticket-email">Email</Trans>
							</Typography>
						</Grid>
						<Grid item xs={12} md={10}>
							<MatesTextField
								variant={"outlined"}
								label={t({
									id: "sf-ticket-email",
									message: "Email",
								})}
								name="email"
								control={this.props.control}
								trigger={this.props.trigger}
								formState={this.props.formState}
							/>
						</Grid>

						<Grid item xs={12} md={2} display="flex" alignItems="center">
							<Typography>
								<Trans id="sf-ticket-object">Oggetto</Trans>
							</Typography>
						</Grid>
						<Grid item xs={12} md={10}>
							<MatesTextField
								variant={"outlined"}
								label={t({
									id: "sf-ticket-object",
									message: "Oggetto",
								})}
								name="object"
								control={this.props.control}
								trigger={this.props.trigger}
								formState={this.props.formState}
							/>
						</Grid>

						<Grid item xs={12} md={2} display="flex" alignItems="center">
							<Typography>
								<Trans id="sf-ticket-type">Tipo richiesta</Trans>
							</Typography>
						</Grid>
						<Grid item xs={12} md={10}>
							<MatesSelect
								variant={"outlined"}
								label={t({
									id: "sf-ticket-type",
									message: "Tipo richiesta",
								})}
								name="type"
								control={this.props.control}
								trigger={this.props.trigger}
								formState={this.props.formState}
							>
								{requestTypes.map((type) => (
									<option value={type} key={type}>{type}</option>
								))}
							</MatesSelect>
						</Grid>

						<Grid item xs={12} sx={{  mt: 2 }}>
							<Box sx={{ width: '100%', pt: 0, position: "relative" }}>
								<PageSectionTitle title={t({ id: "sf-ticket-tickets", message: "Messaggio" })} />
								<MatesMultilineTextField
									variant={"outlined"}
									label={t({
										id: "sf-ticket-message",
										message: "Messaggio",
									})}
									name="message"
									control={this.props.control}
									trigger={this.props.trigger}
									formState={this.props.formState}
									maxLength={254}
									rows={4}
								/>
								<Stack direction="row-reverse" spacing={2} sx={{ pr: 2, pb: 1 }}>
									<Button
										variant="contained"
										type={undefined}
										disableElevation
										sx={{
											textTransform: 'none',
											backgroundColor: '#4d535c',
											color: 'white',
											paddingX: 5,
										}}>
										<Typography>
											<Trans id="sf-ticket-close-button">
												Chiudi
											</Trans>
										</Typography>
									</Button>
									<Button
										variant="contained"
										type={"submit"}
										disableElevation
										sx={{
											textTransform: 'none',
											backgroundColor: 'secondary.main',
											color: 'white',
											paddingX: 5,
										}}>
										<Typography>
											<Trans id="sf-ticket-submit-button">
												Salva
											</Trans>
										</Typography>
									</Button>
								</Stack>
							</Box>
						</Grid>
					</Grid>

			</form>
		</>
	}

}

export default withUseFormHook<{}>(SupportForm, SupportFormSchema, {});
